// eslint-disable

export const onUpdateRecorder = `subscription OnUpdateRecorder($organizationId: ID!) {
  onUpdateRecorder(organizationId: $organizationId) {
    id
    assign
    connected
    name
    organizationId
    status
    version
    type
    tenant
    application
    timestamp
    network
  }
}
`
